module.exports = __webpack_public_path__ + "static/media/IPAD-KEEPME.e9bb66aa.png";